module.exports = __webpack_public_path__ + "static/media/Program8.ed8ab198.jpg";